<template>
  <div class='about_con'>
    <div class='pub_top_block w_1200'>
      <dl>
        <dt>
          <h3>Caldecott Family</h3>
          <div v-if='device !== "mobile"' class='text' v-html='$t("about.desc")'></div>
        </dt>
      </dl>
      <div class='img_bg'>
        <img src='@/assets/img/photo_family@2x.png' alt='' class='bg' width='455' height='455' style='transform:rotate(2deg);right:43px;top:43px'>
      </div>
      <div v-if='device === "mobile"' class='text' v-html='$t("about.desc")'></div>
      <div class='text_center'>
        <router-link to='/recruitList' class='more more2'>{{ $t('about.button') }}</router-link>
      </div>
    </div>
    <template v-if='$i18n.locale !== "en"'>
      <div class='block2 bg_f5'>
        <div class='intro_block w_1200'>
          <div class='pub_tit'>{{ $t('about.develop.title') }}</div>
          <div class='develop_list'>
            <ul v-for='(item, index) in $t("about.develop.list")' :key='index' class='develop_item'>
              <li v-for='(item2, index2) in item' :key='index2' class='text'>{{ item2 }}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class='block3'>
        <div class='intro_block w_1200'>
          <div class='pub_tit'>{{ $t('about.category.title') }}</div>
          <ul class='category_list'>
            <li v-for='(item, index) in $t("about.category.list")' :key='index' class='category_item'>
              <div class='sub_tit'>{{ item.title }}</div>
              <div v-for='(item2, index2) in item.list' :key='index2' class='' v-html='item2'></div>
            </li>
          </ul>
        </div>
      </div>
      <div class='block2 bg_f5'>
        <div class='intro_block w_1200'>
          <div class='pub_tit'>{{ $t('about.slogan.title') }}</div>
          <ul class='slogan_list'>
            <li v-for='(item, index) in $t("about.slogan.list")' :key='index' class='slogan_item'>
              <div class='sub_tit'>{{ item.title }}</div>
              <div>{{ item.desc }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class='block3'>
        <div class='intro_block w_1200'>
          <div class='pub_tit'>{{ $t('about.publish.title') }}</div>
          <div class='text' v-html='$t("about.publish.desc")'></div>
        </div>
      </div>
    </template>
    <div class='block2 bg_f5'>
      <div class='w_1200'>
        <div class='pub_tit'>{{ $t('about.news.title') }}</div>
        <div class='swiper-container'>
          <ul v-if='newsList.length' class='fz_0 swiper-wrapper'>
            <li v-for='(item, index) in newsList' :key='item.id' class='li1 swiper-slide' :data-jumpUrl='"/company-newsDetail/"+item.id'>
              <div class='li_con'>
                <div class='yy yy1'></div>
                <div class='img_box pro_img'><img :src='item.cover_picture' alt=''></div>
                <h3>{{ item.title }}</h3>
                <div class='date'>{{ item.date }}</div>
              </div>
              <img :src='index % 2 == 0 ? Round : Rectangle' width='151' height='151' alt='' class='bg'>
            </li>
          </ul>
        </div>
        <div class='text_center'>
          <router-link to='/company-newsList' class='more more2'>{{ $t('about.news.more') }}</router-link>
        </div>
      </div>
    </div>
    <div class='block3'>
      <div class='w_1200'>
        <div class='pub_tit'>{{ $t('about.address.title') }}</div>
        <div class='cf fz_0 info'>
          <div class='img_box dis_ib ver_m'><img src='@/assets/img/address.png' alt=''></div>
          <dl class='dis_ib ver_m'>
            <dt>
              <h3 v-html='$t("about.address.detail")'></h3>
              <p>{{ $t('about.address.distance') }}</p>
            </dt>
            <dd><a href='javascript:void(0)' class='more more2' @click='findMe'>{{ $t('about.address.button') }}</a></dd>
          </dl>
        </div>
      </div>
    </div>
    <!-- 子底部模块 -->
    <pub-bottom />
  </div>
</template>

<script>
import { setTitle, mediaDevice } from '@/utils'
import Swiper from 'swiper'
import { getAllNews } from '@/service'
import Round from '@/assets/icons/Oval@2x(1).png'
import Rectangle from '@/assets/icons/Rectangle@2x.png'
import PubBottom from '@/components/PubBottom'

export default {
  name: 'Home',
  components: { PubBottom },
  data () {
    return {
      newsList: [],
      Round,
      Rectangle,
      device: mediaDevice(),
      mySwiper: null,
    }
  },
  mounted () {
    getAllNews().then(res => {
      this.newsList = res.data.items
      this.$nextTick(() => { // 下一个UI帧再初始化swiper
        this.initSwiper()
      })
    })
  },
  methods: {
    initSwiper () {
      this.mySwiper = new Swiper('.swiper-container', {
        slidesOffsetBefore: mediaDevice() === 'mobile' ? 145 : 0,
        slidesOffsetAfter: mediaDevice() === 'mobile' ? 20 : 0,
        spaceBetween: 50,
        autoplay: true,
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: false,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        on: {
          click: (e) => {
            let url = e.target.closest('.swiper-slide').dataset.jumpurl
            this.toNewPage(url)
          },
        },
      })
      this.mySwiper.el.onmouseover = () => {
        this.mySwiper.autoplay.stop()
      }
      this.mySwiper.el.onmouseleave = () => {
        this.mySwiper.autoplay.start()
      }
    },
    findMe () {
      window.open('https://map.baidu.com/poi/%E4%B8%AD%E5%A4%AE%E5%A4%A7%E9%81%93D%E5%BA%A7/@12675752.267102875,2564742.4450000003,19z?uid=873447ec06cd413333169bef&primaryUid=5676537026088865454&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&querytype=detailConInfo&da_src=shareurl')
    },
    toNewPage (link) {
      this.$router.push({ path: link })
    },
    init () {
      window.addEventListener('resize', () => {
        this.device = mediaDevice()
      })
    },
  },
  // 广东省，深圳市，宝安区，悦和路2-49，中央大道D座4E-F
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('home.navigation.about')}`)
    this.init()
  },
}
</script>
